import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import { fetchVocabularies, toggleVocabulariesPresentation } from '../actions';

const VocabulariesPanelContainer = ({
  readErrors,
  canEdit,
  className,
  children,
}) => {
  if (!canEdit || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-vocabularies-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions: { vocabularies: { update } } } },
  vocabularies: { vocabularies },
}, { category, displayAs }) => {
  const item = vocabularies[category];
  return {
    canEdit: update,
    currentPage: item.currentPage,
    display: displayAs || item.display,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    total: item.count,
    vocabularies: item.results,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchVocabularies,
  togglePresentation: toggleVocabulariesPresentation,
};

export default VocabulariesPanelContainer;
